module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-10-Classes-Inactive-4f234f64546647c39a9e6abfdb6d7a41.png";